"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateGuid = void 0;
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var uuid_1 = require("uuid");
/**
 * Generates an uuid v4 string.
 *
 * @returns An uuidv4 string.
 */
function generateGuid() {
    return (0, uuid_1.v4)();
}
exports.generateGuid = generateGuid;
//# sourceMappingURL=protocol-base.js.map